import { PanelBody, SelectControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

import LoopColumnsControls from "../../../_shared/loop-columns-controls";

// Keep in sync with $allowed_image_ratios in Blocks/ProductTemplate.php, which
// whitelists these values before writing them into the wrapper style attribute.
const imageRatioOptions = [
  { label: __("Original", "brandy-blocks"), value: "auto" },
  { label: __("Square (1:1)", "brandy-blocks"), value: "1" },
  { label: __("Landscape (4:3)", "brandy-blocks"), value: "4/3" },
  { label: __("Portrait (3:4)", "brandy-blocks"), value: "3/4" },
  { label: __("Wide (16:9)", "brandy-blocks"), value: "16/9" },
  { label: __("Tall (4:5)", "brandy-blocks"), value: "4/5" },
  { label: __("Classic (3:2)", "brandy-blocks"), value: "3/2" },
];

export default function LayoutPanel({ displayLayout, updateLayout, isSlider }) {
  return (
    <PanelBody title={__("Layout", "brandy-blocks")}>
      <LoopColumnsControls
        displayLayout={displayLayout}
        updateLayout={updateLayout}
        isSlider={isSlider}
      />
      <SelectControl
        __nextHasNoMarginBottom
        __next40pxDefaultSize
        label={__("Image ratio", "brandy-blocks")}
        help={__(
          "Crops every product image to the same shape so cards line up. Choose Original to keep each image's own proportions.",
          "brandy-blocks"
        )}
        value={displayLayout.imageRatio ?? "auto"}
        options={imageRatioOptions}
        onChange={(value) => updateLayout({ imageRatio: value })}
      />
      {/* Columns live here but the gap lives on the child, following Query Loop
          (core/post-template owns blockGap; core/query has no spacing support).
          Signposted rather than duplicated, so there is still one control. */}
      <p className="components-base-control__help">
        {__(
          "Spacing between products comes from the Product Template block's Block spacing, as it does in the Query Loop.",
          "brandy-blocks"
        )}
      </p>
    </PanelBody>
  );
}
